export const FLAT_RENT_REASONS = [
  'Квартира уже свободна?',
  'Когда можно посмотреть?',
  'Куда рядом можно сходить?',
  'К вам можно с животными?',
  'К вам можно с детьми?',
];
